<template>
  <div
    class="payment-card-wrapper"
    v-if="physical_card !== 'null' && physicalCardMessage === 'true'"
  >
    <input
      ref="input"
      type="radio"
      name="payment-method"
      disabled="disabled"
      autocomplete="off"
      :class="{ 'is-selected': true }"
    />
    <div class="payment-card payment-card--physical-card">
      <div class="payment-card-header">
        <h3 class="payment-card-header__title">Cartão Físico</h3>
      </div>

      <div class="payment-card-content">
        <div class="payment-card-value">
          <h4 class="payment-card-value__title">
            <small>R$</small>
            {{ physical_card }}
          </h4>
          <p class="payment-card-value__description">Cobrança Única</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormPaymentCard',
  props: ['disabled', 'selected'],
  data() {
    return {
      physical_card: sessionStorage.physical_card,
      physicalCardMessage: sessionStorage.physical_card_message
    };
  }
};
</script>

<style lang="scss">
.payment-card--physical-card {
  height: 176px;
  margin-top: 16px;
}
</style>
